import React from 'react';
import { Bubble, Button, Text } from 'tea-component';
export const relevantTableConfig = (
  cvmList: { [key: string]: unknown; }[],
  handleOnClickUserActions: (...args: any[]) => void,
  isActions = true,
  formatMessage?: (...args: any[]) => void,
) => {
  const filedsTitleOne = isActions ? 'table_database' : 'table_column_name';
  const filedsTitleTwo = isActions ? 'table' : 'table_data_type';
  return {
    cvmList: cvmList || [],
    columns: [
      {
        key: filedsTitleOne,
        width: 200,
        header: (
          <div className="table-title">{formatMessage?.(filedsTitleOne)}</div>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-cont-text">{cvm?.database || cvm?.name}</div>
        ),
      },
      {
        key: filedsTitleTwo,
        width: 300,
        header: (
          <div className="table-title">{formatMessage?.(filedsTitleTwo)}</div>
        ),
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">
            {/* <Text parent="div" style={commonStyle} overflow tooltip>
                                {cvm?.table || cvm?.type}
                            </Text> */}
            {cvm?.table || cvm?.type}
          </div>
        ),
      },
      {
        key: 'description',
        header: (
          <div className="table-title">
            {formatMessage?.('table_description')}
          </div>
        ),
        width: 800,
        align: 'left',
        render: (cvm: any) => (
          <div className="table-text">{cvm.description || cvm?.desc || '-'}</div>
        ),
      },
      isActions && {
        key: 'action',
        width: 150,
        fixed: 'right',
        header: (
          <div className="table-title">
            {formatMessage?.('table_operation')}
          </div>
        ),
        render: (cvm: any) => (
          <>
            <Button
              className="table-btn"
              type="link"
              onClick={() => handleOnClickUserActions(cvm, 'detail')}
            >
              {formatMessage?.('table_details')}
            </Button>
            <Button
              className="table-btn"
              type="link"
              onClick={() => handleOnClickUserActions(cvm, 'del')}
            >
              {formatMessage?.('table_delete')}
            </Button>
          </>
        ),
      },
    ],
  };
};
